import * as yup from 'yup';

const fraudTxFormSchema = yup.object().shape({
  monoovaId: yup.string().required('Monoova Id is required')
});

export default fraudTxFormSchema;
